import React, { useState, useEffect } from "react";
import axiosInstance from "../axiosinstance";
import { useNavigate, useParams } from "react-router-dom";
// import "./Forms.css";

import { Snackbar, Alert as MuiAlert } from "@mui/material"; // Import MuiAlert as Alert
import API_URL from "../Config"; // Adjust the path based on your file structure

export default function EditAdmins({ isSidebarExpanded }) {
  const [userData, setUserData] = useState({
    adminName: "",
    firmName: "",
    email: "",
    phoneNumber: "",
  });
  const { Admin_id } = useParams(); // Retrieve the admin ID from the URL
  const navigate = useNavigate();

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [technikPersons, setTechnikPersons] = useState([]);

  // Validate form data
  const validateForm = () => {
    const newErrors = {};
    if (!userData.adminName) newErrors.adminName = "Admin Name is required.";
    if (!userData.firmName) newErrors.firmName = "Firm Name is required.";
    if (!userData.email) newErrors.email = "Email is required.";
    if (!userData.phoneNumber)
      newErrors.phoneNumber = "Phone number is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Fetch admin data for the given admin_id
  const fetchAdminData = async () => {
    try {
      const response = await axiosInstance.get(
        `/api/get_admin_by_id/${Admin_id}`
      );

      if (response.status === 200) {
        const data = response.data;
        setUserData({
          adminName: data.result.Admin_name,
          firmName: data.result.Firm_name,
          email: data.result.Admin_Email,
          phoneNumber: data.result.Contact_Number,
        });
      } else {
        setSnackbarMessage("Failed to fetch admin data");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error fetching admin data:", error);
      setSnackbarMessage("An error occurred while fetching the admin data");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  // Save the updated admin data
  const handleSaveClick = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      setSnackbarMessage("Please fill in all required fields.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    try {
      setIsLoading(true);

      const response = await axiosInstance.put(`/api/edit_admin/${Admin_id}`, {
        AdminName: userData.adminName,
        AdminEmail: userData.email,
        ContactNumber: userData.phoneNumber,
        firm_name: userData.firmName,
      });

      if (response.status === 200) {
        setSnackbarMessage("Admin updated successfully");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setTimeout(() => {
          navigate("/CA-Admin");
        }, 1000);
      } else {
        setSnackbarMessage("Failed to update admin");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error saving admin:", error);
      setSnackbarMessage("An error occurred while updating the admin");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  // Cancel editing and navigate back
  const handleCancel = () => {
    window.history.back();
  };

  // Fetch all firms to populate the firm selection dropdown
  const allFirms = async () => {
    try {
      const response = await axiosInstance.get("/api/get_all_firms");

      if (response.status === 200) {
        const firms = response.data.data;
        const firmNames = firms.map((company) => ({
          label: company.firm_name,
          value: company.firm_id,
        }));
        setTechnikPersons(firmNames);
      } else {
        console.error("Failed to fetch firms");
      }
    } catch (error) {
      console.error("Error fetching firm data:", error.message);
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    if (Admin_id) {
      fetchAdminData();
      allFirms();
    } else {
      setSnackbarMessage("Admin ID is missing");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  }, [Admin_id]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <div
      className={`table-container ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="table-container-content form-main-body">
        <h1 className="form-title">Edit Admins</h1>
        <div className="form-body">
          <form onSubmit={handleSaveClick}>
            <div className="form-body-container">
              <div className="form-group">
                <label className="form-label">
                  Admin Name<span className="required">*</span>
                </label>
                <div className="form-inputs">
                  <input
                    type="text"
                    name="adminName"
                    className="input-field"
                    placeholder="Enter Admin Name"
                    value={userData.adminName}
                    onChange={handleChange}
                    required
                  />
                  {errors.adminName && (
                    <p className="error">{errors.adminName}</p>
                  )}
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">
                  Firm Name<span className="required">*</span>
                </label>
                <div className="form-inputs">
                  <select
                    name="firmName"
                    className="input-field"
                    value={userData.firmName}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select a Firm</option>
                    {technikPersons.map((firm) => (
                      <option key={firm.label} value={firm.label}>
                        {firm.label}
                      </option>
                    ))}
                  </select>
                  {errors.firmName && (
                    <p className="error">{errors.firmName}</p>
                  )}
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">
                  Email<span className="required">*</span>
                </label>
                <div className="form-inputs">
                  <input
                    type="email"
                    name="email"
                    className="input-field"
                    placeholder="Enter Email"
                    value={userData.email}
                    onChange={handleChange}
                    required
                  />
                  {errors.email && <p className="error">{errors.email}</p>}
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">
                  Phone<span className="required">*</span>
                </label>
                <div className="form-inputs">
                  <input
                    type="tel"
                    name="phoneNumber"
                    className="input-field"
                    placeholder="Enter Phone"
                    value={userData.phoneNumber}
                    onChange={handleChange}
                    required
                  />
                  {errors.phoneNumber && (
                    <p className="error">{errors.phoneNumber}</p>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="form-footer">
        <div className="button-group">
          <button
            type="button"
            className="btn btn-cancel"
            onClick={handleCancel}
          >
            CANCEL
          </button>
          <button
            type="submit"
            className="btn btn-save"
            onClick={handleSaveClick}
          >
            SAVE
          </button>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ transform: "translateY(50px)", marginLeft: "20px", zIndex: 20000 }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}
